import { filter } from 'lodash';
import { sentenceCase } from 'change-case';
import { useEffect, useState } from 'react';
import { Link as RouterLink } from 'react-router-dom';
// material
import {
  Card,
  Table,
  Stack,
  Avatar,
  Button,
  Checkbox,
  TableRow,
  TableBody,
  TableCell,
  Container,
  Typography,
  TableContainer,
  TablePagination,
  LinearProgress,
  Box,
  IconButton,
  Link
} from '@mui/material';
// components
import Page from '../../components/Page';
import Label from '../../components/Label';
import Scrollbar from '../../components/Scrollbar';
import Iconify from '../../components/Iconify';
import SearchNotFound from '../../components/SearchNotFound';
import { UserListHead, UserListToolbar, UserMoreMenu, UserForm } from './table';
// mock
import { DetailsBox } from './modules';
import { useTheme } from '@mui/material/styles';
import { getProductivityReport } from 'src/api/productivity';
import DetailsLocBox from './modules/DetailsLocBox';

// ----------------------------------------------------------------------

const TABLE_HEAD = [
  { id: 'sno', label: 'S No', alignRight: false },
  { id: 'name', label: 'Camera Name', alignRight: false },
  { id: 'role', label: 'Present Duration', alignRight: false },
  { id: 'isVerified', label: 'Absent Duration', alignRight: false },
  { id: 'sleep', label: 'Sleeping Duration', alignRight: false },
  { id: 'status', label: 'Progress', alignRight: false },
  // { id: '' },
];

// ----------------------------------------------------------------------

function descendingComparator(a, b, orderBy) {
  if (b[orderBy] < a[orderBy]) {
    return -1;
  }
  if (b[orderBy] > a[orderBy]) {
    return 1;
  }
  return 0;
}

function getComparator(order, orderBy) {
  return order === 'desc'
    ? (a, b) => descendingComparator(a, b, orderBy)
    : (a, b) => -descendingComparator(a, b, orderBy);
}

function applySortFilter(array, comparator, query) {
  const stabilizedThis = array.map((el, index) => [el, index]);
  stabilizedThis.sort((a, b) => {
    const order = comparator(a[0], b[0]);
    if (order !== 0) return order;
    return a[1] - b[1];
  });
  if (query) {
    return filter(array, (_user) => _user.name.toLowerCase().indexOf(query.toLowerCase()) !== -1);
  }
  return stabilizedThis.map((el) => el[0]);
}

function LinearProgressWithLabel(props) {
    return (
      <Box sx={{ display: 'flex', alignItems: 'center' }}>
        <Box sx={{ width: '100%', mr: 1 }}>
          <LinearProgress variant="determinate" {...props} />
        </Box>
        <Box sx={{ minWidth: 35 }}>
          <Typography variant="body2" color="text.secondary">{`${Math.round(
            props.value,
          )}%`}</Typography>
        </Box>
      </Box>
    );
  }

export default function LocReportTable({ filterData, reportData, dataType }) {
  
  const [page, setPage] = useState(0);

  const [order, setOrder] = useState('asc');

  const [selected, setSelected] = useState([]);

  const [orderBy, setOrderBy] = useState('name');

  const [filterName, setFilterName] = useState('');

  const [rowsPerPage, setRowsPerPage] = useState(5);

  const [isOpen, setOpen] = useState(false);


  TABLE_HEAD[1].label = dataType === 'location' ? 'Location Name' : 'Camera Name'; 

  const handleRequestSort = (event, property) => {
    const isAsc = orderBy === property && order === 'asc';
    setOrder(isAsc ? 'desc' : 'asc');
    setOrderBy(property);
  };

  const handleSelectAllClick = (event) => {
    if (event.target.checked) {
      const newSelecteds = reportData.map((n) => n.name);
      setSelected(newSelecteds);
      return;
    }
    setSelected([]);
  };

  const handleClick = (event, name) => {
    const selectedIndex = selected.indexOf(name);
    let newSelected = [];
    if (selectedIndex === -1) {
      newSelected = newSelected.concat(selected, name);
    } else if (selectedIndex === 0) {
      newSelected = newSelected.concat(selected.slice(1));
    } else if (selectedIndex === selected.length - 1) {
      newSelected = newSelected.concat(selected.slice(0, -1));
    } else if (selectedIndex > 0) {
      newSelected = newSelected.concat(selected.slice(0, selectedIndex), selected.slice(selectedIndex + 1));
    }
    setSelected(newSelected);
  };

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };

  const handleFilterByName = (event) => {
    setFilterName(event.target.value);
  };

  const emptyRows = page > 0 ? Math.max(0, (1 + page) * rowsPerPage - reportData.length) : 0;

  const filteredUsers = applySortFilter(reportData, getComparator(order, orderBy), filterName);

  const isUserNotFound = filteredUsers.length === 0;



  function handleDialog (value=false) {
    setOpen(value)
  }

  const theme = useTheme()

  const [details, setDetails] = useState({ open: false, data: {} });

  function handleDialog (value=false, data={}, detailsType="present") {
    setDetails({...details, open:value, data: data, type: dataType, detailsType: detailsType})
  }
  
  return (

        <>
          <DetailsLocBox dialogHandler={handleDialog} dialogConfig={details}/>
          <UserListToolbar numSelected={selected.length} filterName={filterName} onFilterName={handleFilterByName} />

          <Scrollbar>
            <TableContainer sx={{ minWidth: 800, borderRadius: 0 }}>
              <Table>
                <UserListHead
                  order={order}
                  orderBy={orderBy}
                  headLabel={TABLE_HEAD}
                  rowCount={reportData.length}
                  numSelected={selected.length}
                  onRequestSort={handleRequestSort}
                  onSelectAllClick={handleSelectAllClick}
                />
                <TableBody>
                  {filteredUsers.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage).map((row, idx) => {
                    const { absent_duration, present_duration, locationname, cameraname, progress_percent } = row;
                    const isItemSelected = selected.indexOf(locationname) !== -1;

                    const isDisplay = filterData.type === 'all' || 
                    (filterData.type.toLowerCase() === 'low' && Number(progress_percent) < 80) ||
                    (filterData.type.toLowerCase() === 'medium' && Number(progress_percent) >= 80 && Number(progress_percent) < 90) ||
                    (filterData.type.toLowerCase() === 'high' && Number(progress_percent) >= 90)

                    return isDisplay && (
                      <TableRow
                        hover
                        key={idx}
                        tabIndex={-1}
                        role="checkbox"
                        selected={isItemSelected}
                        aria-checked={isItemSelected}
                        sx={{ backgroundColor: Number(progress_percent) > 90 ? 'auto': (Number(progress_percent) > 80 ? theme.palette.warning.lighter: theme.palette.error.lighter) }}
                      >
                        <TableCell>{idx+1}</TableCell>
                        <TableCell align="left">{dataType === 'location' ? locationname: cameraname}</TableCell>
                        <TableCell align="left"><Link onClick={() => handleDialog(true, row)}>{present_duration}</Link></TableCell>
                        <TableCell align="left"><Link onClick={() => handleDialog(true, row, 'absent')}>{absent_duration}</Link></TableCell>
                        <TableCell align="left"><Link>00:00:00</Link></TableCell>
                        <TableCell align="left">
                          <LinearProgressWithLabel value={Number(progress_percent)} color={Number(progress_percent) > 90 ? 'success': (Number(progress_percent) > 80 ? 'warning': 'error')} />
                        </TableCell>

                        {/* <TableCell align="right">
                          <IconButton onClick={() => handleDialog(true, row)}>
                            <Iconify icon="eva:alert-circle-outline" width={20} height={20} />
                          </IconButton>                          
                        </TableCell> */}
                      </TableRow>
                    );
                  })}
                  {emptyRows > 0 && (
                    <TableRow style={{ height: 53 * emptyRows }}>
                      <TableCell colSpan={6} />
                    </TableRow>
                  )}
                </TableBody>

                {isUserNotFound && (
                  <TableBody>
                    <TableRow>
                      <TableCell align="center" colSpan={6} sx={{ py: 3 }}>
                        <SearchNotFound searchQuery={filterName} />
                      </TableCell>
                    </TableRow>
                  </TableBody>
                )}
              </Table>
            </TableContainer>
          </Scrollbar>

          <TablePagination
            rowsPerPageOptions={[5, 10, 25]}
            component="div"
            count={reportData.length}
            rowsPerPage={rowsPerPage}
            page={page}
            onPageChange={handleChangePage}
            onRowsPerPageChange={handleChangeRowsPerPage}
          />
        </>
  );
}
